import { Slider, SliderTrack, SliderFilledTrack, SliderThumb, Text, Box } from "@chakra-ui/react";

export default function SaturationThresholdToggle({ value, onChange }) {
  return (
    <Box maxW="300px">
      <Text fontSize="sm" mb={1}>Minimum Saturation: {(value * 100).toFixed(0)}%</Text>
      <Slider
        aria-label="saturation-threshold"
        defaultValue={value}
        min={0}
        max={1}
        step={0.05}
        onChange={onChange}
      >
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb />
      </Slider>
    </Box>
  );
}
